import { render, staticRenderFns } from "./navigation-breadcrumb.vue?vue&type=template&id=3683d713&scoped=true&"
import script from "./navigation-breadcrumb.vue?vue&type=script&lang=js&"
export * from "./navigation-breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&id=3683d713&scoped=true&lang=scss&"
import style1 from "@/assets/dropdown-css.scss?vue&type=style&index=1&id=3683d713&scoped=true&lang=scss&"
import style2 from "./navigation-breadcrumb.vue?vue&type=style&index=2&id=3683d713&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3683d713",
  null
  
)

component.options.__file = "navigation-breadcrumb.vue"
export default component.exports